"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DEVICE_TYPE = void 0;

/* eslint-disable max-len */
var BYNDER_URL_PREFIX = 'https://cam.scentregroup.io/m/';
var CLOUDINARY_URL_PREFIX = 'https://res.cloudinary.com/';
var CLOUDINARY_URL_POSTFIX = '/video/upload/';
var CLOUDINARY_MAPPED_FOLDER = '/cinematograph_media/';
var DESKTOP_OPTIONS = 'vc_h264,c_fill,g_center,h_1028,w_2400';
var MOBILE_OPTIONS = 'vc_h264,c_fill,g_center,h_426,w_640';
var SQUARE_OPTIONS = 'vc_h264,f_mp4,c_fill,g_center,h_1024,w_1024';
var WIDE_OPTIONS = 'vc_h264,f_mp4,c_fill,g_center,ar_21:9,w_2048';
var DEVICE_TYPE = Object.freeze({
  mobile: 'mobile',
  desktop: 'desktop',
  square: 'square',
  wide: 'wide'
});
exports.DEVICE_TYPE = DEVICE_TYPE;

var stripOutBynderUrl = function stripOutBynderUrl(url) {
  return url.replace(BYNDER_URL_PREFIX, '');
};

var getOptionsByDeviceType = function getOptionsByDeviceType(deviceType) {
  switch (deviceType) {
    case DEVICE_TYPE.square:
      return SQUARE_OPTIONS;

    case DEVICE_TYPE.wide:
      return WIDE_OPTIONS;

    case DEVICE_TYPE.desktop:
      return DESKTOP_OPTIONS;

    default:
      return MOBILE_OPTIONS;
  }
};

var cloudinaryVideoUrl = function cloudinaryVideoUrl(_ref) {
  var contentfulUrl = _ref.contentfulUrl,
      deviceType = _ref.deviceType,
      _ref$cloudName = _ref.cloudName,
      cloudName = _ref$cloudName === void 0 ? 'scentre-group-au' : _ref$cloudName,
      _ref$removeAudio = _ref.removeAudio,
      removeAudio = _ref$removeAudio === void 0 ? false : _ref$removeAudio;
  var url = stripOutBynderUrl(contentfulUrl);
  var options = getOptionsByDeviceType(deviceType);

  if (removeAudio) {
    options += ',ac_none';
  }

  var x = "".concat(CLOUDINARY_URL_PREFIX).concat(cloudName).concat(CLOUDINARY_URL_POSTFIX).concat(options).concat(CLOUDINARY_MAPPED_FOLDER).concat(url);
  return x;
};

var _default = cloudinaryVideoUrl;
exports.default = _default;